import { Link } from "react-router";
import { Banner, PageHeader } from "../components/ui";

// The closed-account state (migration 0065; UX-DESIGN.md §2.6, §3.7).
// After closure RequireSession answers every route with 403
// account_closed except the statements reads, /v1/me, the session
// re-issue, logout and GET /v1/account/closure
// (internal/auth/session_middleware.go:114-125). The portal learns it from
// the first refused call (AuthProvider accountClosed) and then shows only
// what still works: the statements and the closure record.

/** Portal paths a closed account can still open: the statements and the closure record. */
export function closedAccountAllows(pathname: string, home: string): boolean {
  return (
    pathname === `${home}/statements` ||
    pathname.startsWith(`${home}/statements/`) ||
    pathname === `${home}/close-account`
  );
}

export function ClosedAccountScreen({ home }: { home: string }) {
  return (
    <div className="stack-lg" data-testid="closed-account-screen">
      <PageHeader title="This account is closed" description="Closing ended active use of the portal. Your own financial records stay available." />
      <Banner tone="info" title="Read-only access to your statements">
        <div className="stack-sm">
          <span>
            Issued statements stay available, read-only, for as long as tax and billing records must be kept. Everything else in the portal is
            closed for this account, and it can't be reopened.
          </span>
          <span>
            <Link to={`${home}/statements`}>Open your statements</Link>
          </span>
          <span>
            <Link to={`${home}/close-account`}>See the closure record</Link> (owners and admins)
          </span>
        </div>
      </Banner>
    </div>
  );
}
